import React, {Component} from "react";
import Section from "../layouts/Section";
import {Link} from "react-router-dom";
import {post} from './../../networking/Api'

class NotificationsList extends Component {

    componentDidMount() {
        
    }

    getNotificationsList() {
        
    }

    render() {
        return (
            <Section allNotification={false} searchPopup={true} title={'Notification'}>
                <div className="transaction-area pd-top-36 mg-top-50 mg-bottom-40">
                    <div className="container">
                        <div className="ba-bill-pay-inner">
                                <div className="notifcationEmp">
                                   Employee ID: 453678
                                </div>

                            <div className="ba-single-bill-pay">
                               
                                <div className="notifcationAuthor">
                                   Muhammad Ateek
                                </div>
                                <div className="details">
                                    <h5>Title Recived Money By Aron Fince</h5>
                                    <p>DEscriptiom You have received a payment from Aorn Fice.</p>
                                </div>
                            </div>
                            <div className="amount-inner">
                                <Link className="btn btn-blue" to={'/notification'}>Read</Link>
                            </div>
                        </div>
                        
                        
                    </div>
                </div>
            </Section>
        );
    }
}

export default NotificationsList;